import { AppService } from '../../providers/app.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { routerTransition } from '../../router.animations';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css'],
  animations: [routerTransition()],
  host: {'[@routerTransition]': ''}
})

export class ArticleComponent implements OnInit {
  article: any = {};
  baseUrl: string = environment.baseUrl;

  constructor(private appService: AppService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.article = data.article[0];
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/article/article.component.ts